import React from 'react';
import type { ToastState } from '../../store/seedanceTypes';
import './toast.css';

interface ToastProps {
  toast: ToastState | null;
}

/** 全局轻提示展示组件；显示/隐藏时机由外部 store 或 hook 控制。 */
const Toast: React.FC<ToastProps> = ({ toast }) => {
  return (
    <div className={`toast${toast ? ' on ' + toast.type : ''}`}>
      <div className="ti">
        {toast?.type === 's' ? '✓' : toast?.type === 'i' ? '⏳' : toast?.type === 'e' ? '✕' : ''}
      </div>
      <span>{toast?.msg}</span>
    </div>
  );
};

export default Toast;
